/* PLANS DATA */
export const GET_PLAN_LIST = "GET_PLAN_LIST";
export const SET_PLAN_LIST = "SET_PLAN_LIST";
export const ADD_PLAN = "ADD_PLAN";

export const GET_PLAN_FILTER_DATA = "GET_PLAN_FILTER_DATA";
export const SET_PLAN_FILTER_DATA = "SET_PLAN_FILTER_DATA";

export const PLANS_PROFIT_LOADER = "PLANS_PROFIT_LOADER";
export const GET_PLANS_PROFIT = "GET_PLANS_PROFIT";
export const SET_PLANS_PROFIT = "SET_PLANS_PROFIT";

export const SET_FILTERED_DATE = "SET_FILTERED_DATE";
/* PLANS BULK*/
export const ADD_PLAN_BULK = "PATCH_PLAN_BULK";
export const BULK_LOADER = "BULK_LOADER";
export const DELETE_PLAN_BULK = "DELETE_PLAN_BULK";

export const ADD_PLAN_GROUP = "ADD_PLAN_GROUP";
export const DELETE_PLAN_GROUP = "DELETE_PLAN_GROUP";
export const UPDATE_PLAN_GROUP = "UPDATE_PLAN_GROUP";
export const GET_PLAN_GROUPS = "GET_PLAN_GROUPS";
export const SET_PLAN_GROUPS = "SET_PLAN_GROUPS";

/* PLANS ACTIONS */
export const DELETE_PLAN = "DELETE_PLAN";

/* PLANS DATA PROFILE */
export const GET_PLAN_PROFILE = "GET_PLAN_PROFILE";
export const SET_PLAN_PROFILE = "SET_PLAN_PROFILE";
export const UPDATE_PLAN_PROFILE = "UPDATE_PLAN_PROFILE";
export const SET_ERROR_PLAN_PROFILE = "SET_ERROR_PLAN_PROFILE";

/* USERS DATA*/
export const SET_PLAN_USER_LIST = "SET_PLAN_USER_LIST";

/* PAYOUT DATA */
export const GET_PAYOUT_CONDITIONS = "GET_PAYOUT_CONDITIONS";
export const SET_PAYOUT_CONDITIONS = "SET_PAYOUT_CONDITIONS";
export const UPDATE_PAYOUT_CONDITIONS = "UPDATE_PAYOUT_CONDITIONS";
export const DELETE_PAYOUT_CONDITIONS = "DELETE_PAYOUT_CONDITIONS";
export const ADD_PAYOUT_CONDITIONS = "ADD_PAYOUT_CONDITIONS";

/* LOADER */
export const SHOW_PLAN_LIST_LOADER = "SHOW_PLAN_LIST_LOADER";
export const HIDE_PLAN_LIST_LOADER = "HIDE_PLAN_LIST_LOADER";
export const GROUP_LOADER = "GROUP_LOADER";
export const PAYOUT_LOADER = "PAYOUT_LOADER";

/* ADD ROW */
export const ADD_NEW_ROW_OVERVIEW = "ADD_NEW_ROW_OVERVIEW";
export const REMOVE_NEW_ROW_OVERVIEW = "REMOVE_NEW_ROW_OVERVIEW";

/* ADD CUSTOM PROFIT */
export const ADD_CUSTOM_PROFIT = "ADD_CUSTOM_PROFIT";
export const SET_CUSTOM_PROFIT = "SET_CUSTOM_PROFIT";
export const DELETE_CUSTOM_PROFIT = "DELETE_CUSTOM_PROFIT";
export const UPDATE_CUSTOM_PROFIT = "UPDATE_CUSTOM_PROFIT";
export const EDIT_CUSTOM_PROFIT = "EDIT_CUSTOM_PROFIT";
export const CLOSE_EDIT_CUSTOM_PROFIT = "CLOSE_EDIT_CUSTOM_PROFIT";
export const GET_CUSTOM_PROFIT_BY_DAYS = "GET_CUSTOM_PROFIT_BY_DAYS";
export const SET_CUSTOM_PROFIT_BY_DAYS = "SET_CUSTOM_PROFIT_BY_DAYS";

export const GET_DATA_BY_DAYS = "GET_DATA_BY_DAYS";
export const SET_DATA_BY_DAYS = "SET_DATA_BY_DAYS";
export const LOADER_DATA_BY_DAYS = "LOADER_DATA_BY_DAYS";

export const ADD_CUSTOM_PROFIT_BY_DAYS = "ADD_CUSTOM_PROFIT_BY_DAYS";
export const PATCH_CUSTOM_PROFIT_BY_DAYS = "PATCH_CUSTOM_PROFIT_BY_DAYS";
export const DELETE_CUSTOM_PROFIT_BY_DAYS = "DELETE_CUSTOM_PROFIT_BY_DAYS";
export const LOADER_CUSTOM_PROFIT_BY_DAYS = "LOADER_CUSTOM_PROFIT_BY_DAYS";
export const GET_TOTAL_PLAN = "GET_TOTAL_PLAN";
export const SET_TOTAL_PLAN = "SET_TOTAL_PLAN";

/* CASHBACK BULK */
// export const PATCH_MANAGER_CASHBACK_PLAN_BULK = "PATCH_MANAGER_CASHBACK_PLAN_BULK"
// export const DELETE_MANAGER_CASHBACK_PLAN_BULK = "DELETE_MANAGER_CASHBACK_PLAN_BULK"
// export const ADD_MANAGER_CASHBACK_PLAN_BULK = "ADD_MANAGER_CASHBACK_PLAN_BULK"

export const GET_TOP_MANAGEMENT_REPORTS_FILTERS =
  "GET_TOP_MANAGEMENT_REPORTS_FILTERS";
export const SET_TOP_MANAGEMENT_REPORTS_FILTERS =
  "SET_TOP_MANAGEMENT_REPORTS_FILTERS";
export const LOADER_TOP_MANAGEMENT_REPORTS_FILTERS =
  "LOADER_TOP_MANAGEMENT_REPORTS_FILTERS";

export const GET_PROFIT_PLANS_WIDGET = "GET_PROFIT_PLANS_WIDGET";
export const SET_PROFIT_PLANS_WIDGET = "SET_PROFIT_PLANS_WIDGET";
export const GET_PROFIT_PLAN_OFFERS = "GET_PROFIT_PLAN_OFFERS";
export const SET_PROFIT_PLAN_OFFERS = "SET_PROFIT_PLAN_OFFERS";

export const GET_PROFIT_PLAN_MARGIN = "GET_PROFIT_PLAN_MARGIN";
export const SET_PROFIT_PLAN_MARGIN = "SET_PROFIT_PLAN_MARGIN";

export const GET_PROFIT_PLAN_EXEC = "GET_PROFIT_PLAN_EXEC";
export const SET_PROFIT_PLAN_EXEC = "SET_PROFIT_PLAN_EXEC";

export const GET_AGGREGATED_MANAGERS_PROFIT = "GET_AGGREGATED_MANAGERS_PROFIT";
export const SET_AGGREGATED_MANAGERS_PROFIT = "SET_AGGREGATED_MANAGERS_PROFIT";
export const LOADER_AGGREGATED_MANAGERS_PROFIT = "LOADER_AGGREGATED_MANAGERS_PROFIT";

export const GET_AGGREGATED_OFFER_PROFIT = "GET_AGGREGATED_OFFER_PROFIT";
export const SET_AGGREGATED_OFFER_PROFIT = "SET_AGGREGATED_OFFER_PROFIT";
export const LOADER_AGGREGATED_OFFER_PROFIT = "LOADER_AGGREGATED_OFFER_PROFIT";


export const GET_PROFIT_PLAN_CUSTOM_FILTER = "GET_PROFIT_PLAN_CUSTOM_FILTER";
export const SET_PROFIT_PLAN_CUSTOM_FILTER = "SET_PROFIT_PLAN_CUSTOM_FILTER";
export const LOAD_PROFIT_PLAN_CUSTOM_FILTER = "LOAD_PROFIT_PLAN_CUSTOM_FILTER";

export const GET_PROFIT_PLAN_MARGIN_FILTER = "GET_PROFIT_PLAN_MARGIN_FILTER";
export const SET_PROFIT_PLAN_MARGIN_FILTER = "SET_PROFIT_PLAN_MARGIN_FILTER";
export const LOAD_PROFIT_PLAN_MARGIN_FILTER = "LET_PROFIT_PLAN_MARGIN_FILTER";

export const SET_PROFIT_PLANS_WIDGET_LOADER = "SET_PROFIT_PLANS_WIDGET_LOADER";

export const GET_TOTAL_PROFIT_PLANS = "GET_TOTAL_PROFIT_PLANS";
export const SET_TOTAL_PROFIT_PLANS = "SET_TOTAL_PROFIT_PLANS";

export const GET_PLANS_PROFIT_STATUS = "GET_PLANS_PROFIT_STATUS";

export const GET_PLANS_HR_OFFER_DETAILED = "GET_PLANS_HR_OFFER_DETAILED"
export const SET_PLANS_HR_OFFER_DETAILED = "SET_PLANS_HR_OFFER_DETAILED"
export const LOADER_PLANS_HR_OFFER_DETAILED = "LOADER_PLANS_HR_OFFER_DETAILED"